export const userWindow = {
  PERSONAL_INFO: 1,
  NORIFICATIONS: 2,
  SETTINGS: 3
};
